/**
 * drawer-menu.js — ドロワーメニュー（ハンバーガーメニュー）
 *
 * 機能:
 *  - ハンバーガーボタンクリックでドロワーを開く
 *  - 閉じるボタン / オーバーレイクリックで閉じる
 *  - ESCキーで閉じる
 *  - フォーカストラップ（アクセシビリティ）
 *  - サブメニューのアコーディオン展開
 *  - body スクロール防止（開いている間）
 */

(function () {
  'use strict';

  const drawer = document.getElementById('DrawerMenu');
  const openBtns = document.querySelectorAll('.js-drawer-open');
  const closeBtns = document.querySelectorAll('.js-drawer-close');
  const subToggles = document.querySelectorAll('.drawer-menu__sub-toggle');

  if (!drawer) return;

  /** ドロワーを開く */
  function openDrawer() {
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // ハンバーガーボタンの状態更新
    openBtns.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });

    // フォーカスをドロワー内の最初のフォーカス可能要素へ
    requestAnimationFrame(function () {
      const focusable = drawer.querySelectorAll(
        'button:not([disabled]), a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length) focusable[0].focus();
    });
  }

  /** ドロワーを閉じる */
  function closeDrawer() {
    drawer.setAttribute('hidden', '');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // ハンバーガーボタンの状態更新
    openBtns.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.focus(); // フォーカスを戻す
    });
  }

  // 開くボタン
  openBtns.forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });

  // 閉じるボタン（×ボタン＋オーバーレイ）
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  // ESCキーで閉じる
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) {
      closeDrawer();
    }
  });

  // ----------------------------------------------------------------
  // サブメニュー（アコーディオン）
  // ----------------------------------------------------------------
  subToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const subList = toggle.nextElementSibling;

      // 他のサブメニューを閉じる
      subToggles.forEach(function (other) {
        if (other !== toggle) {
          other.setAttribute('aria-expanded', 'false');
          const otherList = other.nextElementSibling;
          if (otherList) otherList.style.maxHeight = null;
        }
      });

      if (isExpanded) {
        toggle.setAttribute('aria-expanded', 'false');
        if (subList) subList.style.maxHeight = null;
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        if (subList) {
          subList.style.maxHeight = subList.scrollHeight + 'px';
        }
      }
    });
  });

  // ----------------------------------------------------------------
  // フォーカストラップ（Tab キーをドロワー内に閉じ込める）
  // ----------------------------------------------------------------
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;

    const focusables = Array.from(
      drawer.querySelectorAll(
        'button:not([disabled]), a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    );

    if (focusables.length === 0) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

})();
